<div class="brand-overview-page records-page datatable-page-shell" [class.brand-overview-page--embedded]="isEmbeddedContext">
  <div *ngIf="!isEmbeddedContext" class="records-page__hero brand-overview-hero">
    <div class="records-page__hero-primary">
      <div class="records-page__hero-headline">
        <span class="records-page__hero-eyebrow">{{ 'BRAND_DASHBOARD' | translate }}</span>
        <h3 class="records-page__hero-title">{{ companySelected ? getActiveCompanyName() : ('PLEASE_SELECT_COMPANY' | translate) }}</h3>
      </div>
    </div>
  </div>

  <div class="brand-overview-panel brand-overview-panel--summary datatable-page-surface">
    <div class="reportFrame" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px">
      <div class="reportInfo">
        <div class="reportHeader">
          <h2 class="mb-0" *ngIf="isEmbeddedContext">{{ companySelected ? getActiveCompanyName() : ('PLEASE_SELECT_COMPANY' | translate) }}</h2>
          <div *ngIf="companySelected && selectedReportPeriod" class="reportPeriod">
            {{ selectedReportPeriodTitle }}
            <ng-container *ngIf="DateStart && DateStop">({{ DateStart | date:'mediumDate' }} — {{ DateStop | date:'mediumDate' }})</ng-container>
          </div>
        </div>
        <em *ngIf="companySelected">{{ 'REPORTS_QUICK_REFERENCE_DISCLAIMER' | translate }}</em>
      </div>
      <div class="formFrame">
        <div class="reportForm" fxLayout="column">
          <form [formGroup]="reportForm" (ngSubmit)="updateReport()">
            <div class="reportFormRow">
              <!-- Company selector (only if multiple companies) -->
              <ng-container *ngIf="companiesData.length > 1; else singleCompany">
                <div class="formItem formItem--company">
                  <label class="formItemLabel" style="margin-bottom: 7px;">{{ 'COMPANY' | translate }}</label>
                  <ng-select
                    [clearable]="false"
                    [attr.aria-label]="'PLEASE_SELECT_COMPANY' | translate"
                    [ngClass]="{ 'is-invalid': reportForm.controls.companySelector.touched && reportForm.controls.companySelector.errors }"
                    bindLabel="name"
                    bindValue="id"
                    [items]="companiesData"
                    formControlName="companySelector">
                  </ng-select>
                  <div *ngIf="reportForm.controls.companySelector.touched && reportForm.controls.companySelector.errors" class="invalid-feedback">
                    <div *ngIf="reportForm.controls.companySelector.errors.required">{{ 'PLEASE_SELECT_COMPANY' | translate }}</div>
                  </div>
                </div>
              </ng-container>
              <ng-template #singleCompany>
                <input type="hidden" formControlName="companySelector" [value]="selectedCompanyId">
              </ng-template>

              <div class="formItem formItem--period">
                <label class="formItemLabel" style="margin-bottom: 7px;">{{ 'PERIOD' | translate }}</label>
                <ng-select
                  [clearable]="false"
                  [attr.aria-label]="'SELECT_PERIOD' | translate"
                  (change)="onReportPeriodChange($event)"
                  bindLabel="title"
                  bindValue="key"
                  [items]="reportPeriods"
                  formControlName="key">
                </ng-select>
              </div>

              <div class="formItem formItem--date">
                <label class="formItemLabel" for="startDate">{{ 'START' | translate }}</label>
                <input
                  id="startDate"
                  type="date"
                  [readonly]="datesReadonly"
                  formControlName="startDate"
                  class="form-control form-date date-custom"
                  [ngClass]="{ 'is-invalid': reportForm.controls.startDate.errors }" />
                <div *ngIf="reportForm.controls.startDate.errors" class="invalid-feedback">
                  <div *ngIf="reportForm.controls.startDate.errors.required">{{ 'SELECT_PERIOD' | translate }}</div>
                </div>
              </div>

              <div class="formItem formItem--date">
                <label class="formItemLabel" for="stopDate">{{ 'END' | translate }}</label>
                <input
                  id="stopDate"
                  type="date"
                  [readonly]="datesReadonly"
                  formControlName="stopDate"
                  class="form-control form-date date-custom"
                  [ngClass]="{ 'is-invalid': reportForm.controls.stopDate.errors }" />
                <div *ngIf="reportForm.controls.stopDate.errors" class="invalid-feedback">
                  <div *ngIf="reportForm.controls.stopDate.errors.required">{{ 'SELECT_PERIOD' | translate }}</div>
                </div>
              </div>

              <div class="formItem formItem--button">
                <button type="submit" class="blue-button">{{ 'RUN_REPORT' | translate }}</button>
              </div>
            </div>
            <div class="reportFormRow reportFormRow--conversion-actions" *ngIf="combinedReportsPurchases" formGroupName="conversionActionSelections">
              <div class="formItem formItem--conversion-actions">
                <label class="formItemLabel" style="margin-bottom: 7px;">{{ 'CONVERSION_ACTIONS_INCLUDED' | translate }}</label>
                <div class="conversion-action-checkboxes" style="display: flex; flex-wrap: wrap; gap: 12px 24px; align-items: center;">
                  <label
                    class="conversion-action-checkbox"
                    *ngFor="let action of conversionActionOptions"
                    style="display: inline-flex; align-items: center; gap: 8px; margin: 0;">
                    <input type="checkbox" [formControlName]="action.key" />
                    <span>{{ action.labelKey | translate }}</span>
                  </label>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="brand-overview-panel brand-overview-panel--content reportData datatable-page-surface">
      <ng-container *ngIf="loading; else dataContent">
        <div class="loading">
          <div class="la-ball-spin-clockwise la-2x">
            <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
          </div>
        </div>
      </ng-container>
      <ng-template #dataContent>
        <ng-container *ngIf="companyMetaData.length || companyGoogleData.length">
          <div *ngIf="companyMetaData.length && companyGoogleData.length" class="metricsSection metricsSection--combined">
            <h3>{{ 'TOTALS' | translate }}</h3>
            <div class="totals">
              <div class="totalCard">
                <div class="totalMain">
                  <div class="totalLabel">{{ 'CAMPAIGNS' | translate }}</div>
                  <div class="totalValue">{{ totalCombinedCampaigns | number }}</div>
                  <div class="totalPrev"><small>{{ 'PREVIOUS' | translate }}: {{ previousCombinedCampaigns | number }}</small></div>
                </div>
                <ng-container *ngIf="getDeltaInfo(totalCombinedCampaigns, previousCombinedCampaigns) as d">
                  <div class="totalDelta" [ngClass]="d.className">
                    <div class="totalDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                    <div class="totalDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                  </div>
                </ng-container>
              </div>
              <div class="totalCard">
                <div class="totalMain">
                  <div class="totalLabel">{{ 'SPEND' | translate }}</div>
                  <div class="totalValue">{{ totalCombinedSpend | currency:'USD':'symbol':'1.2-2' }}</div>
                  <div class="totalPrev"><small>{{ 'PREVIOUS' | translate }}: {{ prevCombinedSpend | currency:'USD':'symbol':'1.2-2' }}</small></div>
                </div>
                <ng-container *ngIf="getDeltaInfo(totalCombinedSpend, prevCombinedSpend) as d">
                  <div class="totalDelta" [ngClass]="d.className">
                    <div class="totalDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                    <div class="totalDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                  </div>
                </ng-container>
              </div>
              <div class="totalCard">
                <div class="totalMain">
                  <div class="totalLabel">{{ (combinedReportsPurchases ? 'CONVERSION_ACTIONS' : 'LEADS') | translate }}</div>
                  <div class="totalValue">{{ (combinedReportsPurchases ? totalCombinedConversionActions : totalCombinedLeads) | number }}</div>
                  <div class="totalPrev"><small>{{ 'PREVIOUS' | translate }}: {{ (combinedReportsPurchases ? prevCombinedConversionActions : prevCombinedLeads) | number }}</small></div>
                </div>
                <ng-container *ngIf="getDeltaInfo(combinedReportsPurchases ? totalCombinedConversionActions : totalCombinedLeads, combinedReportsPurchases ? prevCombinedConversionActions : prevCombinedLeads) as d">
                  <div class="totalDelta" [ngClass]="d.className">
                    <div class="totalDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                    <div class="totalDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                  </div>
                </ng-container>
              </div>
              <div class="totalCard">
                <div class="totalMain">
                  <div class="totalLabel" *ngIf="!combinedReportsPurchases">{{ 'COST_PER_LEAD' | translate }} ({{ 'CPL' | translate }})</div>
                  <div class="totalLabel" *ngIf="combinedReportsPurchases">{{ 'COST_PER_ACTION' | translate }} ({{ 'CPA' | translate }})</div>
                  <div class="totalValue">{{ (combinedReportsPurchases ? totalCombinedCpa : totalCombinedCpl) | currency:'USD':'symbol':'1.2-2' }}</div>
                  <div class="totalPrev"><small>{{ 'PREVIOUS' | translate }}: {{ (combinedReportsPurchases ? prevCombinedCpa : prevCombinedCpl) | currency:'USD':'symbol':'1.2-2' }}</small></div>
                </div>
                <ng-container *ngIf="getDeltaInfo(combinedReportsPurchases ? totalCombinedCpa : totalCombinedCpl, combinedReportsPurchases ? prevCombinedCpa : prevCombinedCpl, true) as d">
                  <div class="totalDelta" [ngClass]="d.className">
                    <div class="totalDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                    <div class="totalDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                  </div>
                </ng-container>
              </div>
              <div class="totalCard">
                <div class="totalMain">
                  <div class="totalLabel" *ngIf="!combinedReportsPurchases">{{ 'LEAD_SUBMISSION_RATE' | translate }} ({{ 'LSR' | translate }})</div>
                  <div class="totalLabel" *ngIf="combinedReportsPurchases">{{ 'CONVERSION_RATE' | translate }}</div>
                  <div class="totalValue">{{ (combinedReportsPurchases ? totalCombinedConvRate : totalCombinedLsr) | percent:'1.2-2' }}</div>
                  <div class="totalPrev"><small>{{ 'PREVIOUS' | translate }}: {{ (combinedReportsPurchases ? prevCombinedConvRate : prevCombinedLsr) | percent:'1.2-2' }}</small></div>
                </div>
                <ng-container *ngIf="getDeltaInfo(combinedReportsPurchases ? totalCombinedConvRate : totalCombinedLsr, combinedReportsPurchases ? prevCombinedConvRate : prevCombinedLsr) as d">
                  <div class="totalDelta" [ngClass]="d.className">
                    <div class="totalDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                    <div class="totalDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>

          <div *ngIf="companyMetaData.length" class="metricsSection metricsSection--meta">
            <h3>{{ 'PLATFORMS.META' | translate }}</h3>
            <div class="totals">
              <div class="totalCard">
                <div class="totalMain">
                  <div class="totalLabel">{{ 'CAMPAIGNS' | translate }}</div>
                  <div class="totalValue">{{ totalMetaCampaigns | number }}</div>
                  <div class="totalPrev"><small>{{ 'PREVIOUS' | translate }}: {{ previousMetaCampaigns | number }}</small></div>
                </div>
                <ng-container *ngIf="getDeltaInfo(totalMetaCampaigns, previousMetaCampaigns) as d">
                  <div class="totalDelta" [ngClass]="d.className">
                    <div class="totalDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                    <div class="totalDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                  </div>
                </ng-container>
              </div>
              <div class="totalCard">
                <div class="totalMain">
                  <div class="totalLabel">{{ 'SPEND' | translate }}</div>
                  <div class="totalValue">{{ totalMetaSpend | currency:'USD':'symbol':'1.2-2' }}</div>
                  <div class="totalPrev"><small>{{ 'PREVIOUS' | translate }}: {{ prevMetaSpend | currency:'USD':'symbol':'1.2-2' }}</small></div>
                </div>
                <ng-container *ngIf="getDeltaInfo(totalMetaSpend, prevMetaSpend) as d">
                  <div class="totalDelta" [ngClass]="d.className">
                    <div class="totalDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                    <div class="totalDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                  </div>
                </ng-container>
              </div>
              <div class="totalCard">
                <div class="totalMain">
                  <div class="totalLabel">{{ 'CPM' | translate }}</div>
                  <div class="totalValue">{{ totalMetaCpm | currency:'USD':'symbol':'1.2-2' }}</div>
                  <div class="totalPrev"><small>{{ 'PREVIOUS' | translate }}: {{ prevMetaCpm | currency:'USD':'symbol':'1.2-2' }}</small></div>
                </div>
                <ng-container *ngIf="getDeltaInfo(totalMetaCpm, prevMetaCpm, true) as d">
                  <div class="totalDelta" [ngClass]="d.className">
                    <div class="totalDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                    <div class="totalDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                  </div>
                </ng-container>
              </div>
              <div class="totalCard">
                <div class="totalMain">
                  <div class="totalLabel">{{ 'CTR' | translate }}</div>
                  <div class="totalValue">{{ totalMetaCtr | percent:'1.2-2' }}</div>
                  <div class="totalPrev"><small>{{ 'PREVIOUS' | translate }}: {{ prevMetaCtr | percent:'1.2-2' }}</small></div>
                </div>
                <ng-container *ngIf="getDeltaInfo(totalMetaCtr, prevMetaCtr) as d">
                  <div class="totalDelta" [ngClass]="d.className">
                    <div class="totalDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                    <div class="totalDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                  </div>
                </ng-container>
              </div>
              <div class="totalCard">
                <div class="totalMain">
                  <div class="totalLabel">{{ (metaReportsPurchases ? 'CONVERSION_ACTIONS' : 'LEADS') | translate }}</div>
                  <div class="totalValue">{{ (metaReportsPurchases ? totalMetaConversionActions : totalMetaLeads) | number }}</div>
                  <div class="totalPrev"><small>{{ 'PREVIOUS' | translate }}: {{ (metaReportsPurchases ? prevMetaConversionActions : prevMetaLeads) | number }}</small></div>
                </div>
                <ng-container *ngIf="getDeltaInfo(metaReportsPurchases ? totalMetaConversionActions : totalMetaLeads, metaReportsPurchases ? prevMetaConversionActions : prevMetaLeads) as d">
                  <div class="totalDelta" [ngClass]="d.className">
                    <div class="totalDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                    <div class="totalDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                  </div>
                </ng-container>
              </div>
              <div class="totalCard">
                <div class="totalMain">
                  <div class="totalLabel" *ngIf="!metaReportsPurchases">{{ 'CPL' | translate }}</div>
                  <div class="totalLabel" *ngIf="metaReportsPurchases">{{ 'CPA' | translate }}</div>
                  <div class="totalValue">{{ (metaReportsPurchases ? totalMetaCpa : totalMetaCpl) | currency:'USD':'symbol':'1.2-2' }}</div>
                  <div class="totalPrev"><small>{{ 'PREVIOUS' | translate }}: {{ (metaReportsPurchases ? prevMetaCpa : prevMetaCpl) | currency:'USD':'symbol':'1.2-2' }}</small></div>
                </div>
                <ng-container *ngIf="getDeltaInfo(metaReportsPurchases ? totalMetaCpa : totalMetaCpl, metaReportsPurchases ? prevMetaCpa : prevMetaCpl, true) as d">
                  <div class="totalDelta" [ngClass]="d.className">
                    <div class="totalDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                    <div class="totalDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                  </div>
                </ng-container>
              </div>
              <div class="totalCard">
                <div class="totalMain">
                  <div class="totalLabel" *ngIf="!metaReportsPurchases">{{ 'LSR' | translate }}</div>
                  <div class="totalLabel" *ngIf="metaReportsPurchases">{{ 'CONVERSION_RATE' | translate }}</div>
                  <div class="totalValue">{{ (metaReportsPurchases ? totalMetaConvRate : totalMetaLsr) | percent:'1.2-2' }}</div>
                  <div class="totalPrev"><small>{{ 'PREVIOUS' | translate }}: {{ (metaReportsPurchases ? prevMetaConvRate : prevMetaLsr) | percent:'1.2-2' }}</small></div>
                </div>
                <ng-container *ngIf="getDeltaInfo(metaReportsPurchases ? totalMetaConvRate : totalMetaLsr, metaReportsPurchases ? prevMetaConvRate : prevMetaLsr) as d">
                  <div class="totalDelta" [ngClass]="d.className">
                    <div class="totalDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                    <div class="totalDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>

          <div *ngIf="companyGoogleData.length" class="metricsSection metricsSection--google">
            <h3>{{ 'PLATFORMS.GOOGLE' | translate }}</h3>
            <div class="totals">
              <div class="totalCard">
                <div class="totalMain">
                  <div class="totalLabel">{{ 'CAMPAIGNS' | translate }}</div>
                  <div class="totalValue">{{ totalGoogleCampaigns | number }}</div>
                  <div class="totalPrev"><small>{{ 'PREVIOUS' | translate }}: {{ previousGoogleCampaigns | number }}</small></div>
                </div>
                <ng-container *ngIf="getDeltaInfo(totalGoogleCampaigns, previousGoogleCampaigns) as d">
                  <div class="totalDelta" [ngClass]="d.className">
                    <div class="totalDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                    <div class="totalDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                  </div>
                </ng-container>
              </div>
              <div class="totalCard">
                <div class="totalMain">
                  <div class="totalLabel">{{ 'SPEND' | translate }}</div>
                  <div class="totalValue">{{ totalGoogleSpend | currency:'USD':'symbol':'1.2-2' }}</div>
                  <div class="totalPrev"><small>{{ 'PREVIOUS' | translate }}: {{ prevGoogleSpend | currency:'USD':'symbol':'1.2-2' }}</small></div>
                </div>
                <ng-container *ngIf="getDeltaInfo(totalGoogleSpend, prevGoogleSpend) as d">
                  <div class="totalDelta" [ngClass]="d.className">
                    <div class="totalDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                    <div class="totalDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                  </div>
                </ng-container>
              </div>
              <div class="totalCard">
                <div class="totalMain">
                  <div class="totalLabel">{{ 'CPC' | translate }}</div>
                  <div class="totalValue">{{ totalGoogleCpc | currency:'USD':'symbol':'1.2-2' }}</div>
                  <div class="totalPrev"><small>{{ 'PREVIOUS' | translate }}: {{ prevGoogleCpc | currency:'USD':'symbol':'1.2-2' }}</small></div>
                </div>
                <ng-container *ngIf="getDeltaInfo(totalGoogleCpc, prevGoogleCpc, true) as d">
                  <div class="totalDelta" [ngClass]="d.className">
                    <div class="totalDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                    <div class="totalDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                  </div>
                </ng-container>
              </div>
              <div class="totalCard">
                <div class="totalMain">
                  <div class="totalLabel">{{ 'CTR' | translate }}</div>
                  <div class="totalValue">{{ totalGoogleCtr | percent:'1.2-2' }}</div>
                  <div class="totalPrev"><small>{{ 'PREVIOUS' | translate }}: {{ prevGoogleCtr | percent:'1.2-2' }}</small></div>
                </div>
                <ng-container *ngIf="getDeltaInfo(totalGoogleCtr, prevGoogleCtr) as d">
                  <div class="totalDelta" [ngClass]="d.className">
                    <div class="totalDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                    <div class="totalDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                  </div>
                </ng-container>
              </div>
              <div class="totalCard">
                <div class="totalMain">
                  <div class="totalLabel">{{ (googleReportsPurchases ? 'CONVERSION_ACTIONS' : 'LEADS') | translate }}</div>
                  <div class="totalValue">{{ (googleReportsPurchases ? totalGoogleConversionActions : totalGoogleLeads) | number }}</div>
                  <div class="totalPrev"><small>{{ 'PREVIOUS' | translate }}: {{ (googleReportsPurchases ? prevGoogleConversionActions : prevGoogleLeads) | number }}</small></div>
                </div>
                <ng-container *ngIf="getDeltaInfo(googleReportsPurchases ? totalGoogleConversionActions : totalGoogleLeads, googleReportsPurchases ? prevGoogleConversionActions : prevGoogleLeads) as d">
                  <div class="totalDelta" [ngClass]="d.className">
                    <div class="totalDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                    <div class="totalDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                  </div>
                </ng-container>
              </div>
              <div class="totalCard">
                <div class="totalMain">
                  <div class="totalLabel" *ngIf="!googleReportsPurchases">{{ 'CPL' | translate }}</div>
                  <div class="totalLabel" *ngIf="googleReportsPurchases">{{ 'CPA' | translate }}</div>
                  <div class="totalValue">{{ (googleReportsPurchases ? totalGoogleCpa : totalGoogleCpl) | currency:'USD':'symbol':'1.2-2' }}</div>
                  <div class="totalPrev"><small>{{ 'PREVIOUS' | translate }}: {{ (googleReportsPurchases ? prevGoogleCpa : prevGoogleCpl) | currency:'USD':'symbol':'1.2-2' }}</small></div>
                </div>
                <ng-container *ngIf="getDeltaInfo(googleReportsPurchases ? totalGoogleCpa : totalGoogleCpl, googleReportsPurchases ? prevGoogleCpa : prevGoogleCpl, true) as d">
                  <div class="totalDelta" [ngClass]="d.className">
                    <div class="totalDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                    <div class="totalDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                  </div>
                </ng-container>
              </div>
              <div class="totalCard">
                <div class="totalMain">
                  <div class="totalLabel" *ngIf="!googleReportsPurchases">{{ 'LSR' | translate }}</div>
                  <div class="totalLabel" *ngIf="googleReportsPurchases">{{ 'CONVERSION_RATE' | translate }}</div>
                  <div class="totalValue">{{ (googleReportsPurchases ? totalGoogleConvRate : totalGoogleLsr) | percent:'1.2-2' }}</div>
                  <div class="totalPrev"><small>{{ 'PREVIOUS' | translate }}: {{ (googleReportsPurchases ? prevGoogleConvRate : prevGoogleLsr) | percent:'1.2-2' }}</small></div>
                </div>
                <ng-container *ngIf="getDeltaInfo(googleReportsPurchases ? totalGoogleConvRate : totalGoogleLsr, googleReportsPurchases ? prevGoogleConvRate : prevGoogleLsr) as d">
                  <div class="totalDelta" [ngClass]="d.className">
                    <div class="totalDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                    <div class="totalDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
        <div *ngIf="companyMetaData.length || companyGoogleData.length" style="margin-top: 30px;">
          <h2>{{ 'CAMPAIGNS' | translate }}</h2>
          <em>{{ 'MONTHLY_BUDGET_NOTE' | translate }}</em>
          <div class="section-tabs-rail brand-overview-tab-rail" role="tablist" aria-label="Brand overview platforms">
            <button
              *ngIf="hasMetaPlatformData"
              type="button"
              id="meta-data-tab"
              class="section-tab-button brand-overview-tab"
              [class.section-tab-button--active]="activeTab === 'meta'"
              (click)="activeTab = 'meta'"
              role="tab"
              [attr.aria-selected]="activeTab === 'meta'"
              aria-controls="meta-data">
              <h2>{{ 'PLATFORMS.META' | translate }}</h2>
            </button>
            <button
              *ngIf="hasGooglePlatformData"
              type="button"
              id="google-data-tab"
              class="section-tab-button brand-overview-tab"
              [class.section-tab-button--active]="activeTab === 'google'"
              (click)="activeTab = 'google'"
              role="tab"
              [attr.aria-selected]="activeTab === 'google'"
              aria-controls="google-data">
              <h2>{{ 'PLATFORMS.GOOGLE' | translate }}</h2>
            </button>
          </div>
          <div class="brand-overview-tab-content" id="reportTabsContent">
            <div class="brand-overview-tab-panel" *ngIf="hasMetaPlatformData && activeTab === 'meta'" id="meta-data" role="tabpanel" aria-labelledby="meta-data-tab">
              <div class="brand-overview-table-shell">
                <app-report-datatable 
                  [iSortColumn]="'location'"
                  [iSortDirection]="'asc'"
                  [iColumns]="defaultMetaColumns" 
                  [iData$]="companyMetaData"
                  [iTotalCount]="companyMetaData.length"
                  [iShowFooter]="companyMetaData.length > defaultPageSize"
                  [iPageSize]="defaultPageSize"
                  [iTotalData]="companyMetaTableTotals"
                  [iAverageData]="companyMetaAverages"
                  [iReportTitle]="'PLATFORMS.META' | translate"
                >
                </app-report-datatable>
              </div>
            </div>
            <div class="brand-overview-tab-panel" *ngIf="hasGooglePlatformData && activeTab === 'google'" id="google-data" role="tabpanel" aria-labelledby="google-data-tab">
              <div class="brand-overview-table-shell">
                <app-report-datatable 
                  [iSortColumn]="'location'"
                  [iSortDirection]="'asc'"
                  [iColumns]="defaultGoogleColumns" 
                  [iData$]="companyGoogleData"
                  [iTotalCount]="companyGoogleData.length"
                  [iShowFooter]="companyGoogleData.length > defaultPageSize"
                  [iPageSize]="defaultPageSize"
                  [iTotalData]="companyGoogleTableTotals"
                  [iAverageData]="companyGoogleAverages"
                  [iReportTitle]="'PLATFORMS.GOOGLE' | translate"
                >
                </app-report-datatable>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
  </div>
</div>
